import { ContractTemplate } from '../../lib/types/models/contract-template/contract-template'
import { ContractTemplateInput } from '../../lib/types/models/contract-template/contract-template-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createContractTemplate = (data: ContractTemplateInput) => {
  return restApiClient
    .url(constructApiUrl(API.contractTemplate.create.url, null))
    .post<ContractTemplate, ContractTemplateInput>(data)
}
